@if (isTeaserFeatureEnabled()) {
    <div class="teaser-on-product-section">
        <cc-teaser-on-product [casinoProduct]="routeCurrentProduct" [categoryRoute]="routeCategoryType" />
    </div>
}
